// @flow
import { schema } from 'normalizr';

import { monitor } from './monitors';
import { bus } from './buses';
import { tripStop } from './tripStops';
import { school } from './schools';
import { route } from './routes';


export const trip = new schema.Entity('trips', {
  derived_from: route,
  school,
  monitor,
  bus,
  stops: [tripStop],
});
export const arrayOfTrips = new schema.Array(trip);



// WEBPACK FOOTER //
// ./src/scripts/api/schemas/trips.js